import { Injectable } from '@angular/core'

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}

@Injectable()
export abstract class AbstractTrackEventsService {
  abstract trackEvent(event: string, eventCategory: string, eventAction: string, eventLabel: string): void

  abstract trackEventUnitAdded(payload: Record<string, unknown>): void

  abstract trackEventRequestSubmitted(payload: Record<string, unknown>): void

  abstract trackPriceRequestEvent(payload: Record<string, unknown>): void
}
